import React from "react";
import MDBRow from "../../Component/MDBShim/MDBRow";
import MDBCol from "../../Component/MDBShim/MDBCol";
import "../Home/home.css";
import NoteService from "../Security/NoteService/noteService";
import TaskTable from "./taskTable";
import LayerLegacy from "../../LayerLegacy";
import MainContext from "../../Context/MainContext/MainContext";

class Tasks extends LayerLegacy {
  constructor(props) {
    super(props);

    this.state = {
      orders: [],
      tasks: [],
      priority: [],
      isLoaded: false,
    };
  }

  static contextType = MainContext; // For legacy class components

  componentDidMount() {
    this.getTasksForUser();
  }

  getTasksForUser() {
    const { currentUser } = this.context;

    if (currentUser && currentUser.id) {
      NoteService.getOpenTasks(currentUser.id)
        .then((tasks) => {
          this.setState({
            tasks: tasks,
            tasksLoaded: true,
          });
          return Promise.resolve(tasks);
        })
        .catch((err) => {
          console.log(err);
          return Promise.resolve([]);
        });
    }
  }

  renderContent() {
    let props = {
      tasks: this.state.tasks,
      loaded: this.state.tasksLoaded,
    };
    return (
      <MDBRow>
        <MDBCol size="12" style={{ padding: "20px 30px 0px" }}>
          <TaskTable {...props} />
        </MDBCol>
      </MDBRow>
    );
  }
}

export default Tasks;
